import { render, staticRenderFns } from "./PensionCalculator.vue?vue&type=template&id=22288f9d&scoped=true"
import script from "./PensionCalculator.vue?vue&type=script&lang=js"
export * from "./PensionCalculator.vue?vue&type=script&lang=js"
import style0 from "./PensionCalculator.vue?vue&type=style&index=0&id=22288f9d&prod&scoped=true&lang=css"
import style1 from "./PensionCalculator.vue?vue&type=style&index=1&id=22288f9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22288f9d",
  null
  
)

export default component.exports